export enum UserActionTypeAlternateEmailChanged {
  AddedAlternateEmail = 'AddedAlternateEmail',
  EditedAlternateEmail = 'EditedAlternateEmail',
  DeletedAlternateEmail = 'DeletedAlternateEmail'
}
